import { render, staticRenderFns } from "./classificationTree.vue?vue&type=template&id=9d82032e"
import script from "./classificationTree.vue?vue&type=script&lang=js"
export * from "./classificationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports